import React, { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../services/api";

// Multi-language plan gate. The super-admin decides (on Plan & Features) whether
// the switcher exists at all, which languages customers may pick, and the site
// default. When the feature is off the site stays in English and no switcher shows.
const LanguageContext = createContext({
  enabled: false,
  languages: ["en"],
  supported: [],
  current: "en",
  change: () => {},
});

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [cfg, setCfg] = useState({ enabled: false, languages: ["en"], supported: [] });

  useEffect(() => {
    api.get("/i18n/status")
      .then((r) => {
        const { enabled, languages = [], defaultLanguage = "en", supported = [] } = r.data || {};
        setCfg({ enabled: !!enabled, languages, supported });
        const current = (i18n.language || "en").slice(0, 2);
        if (!enabled) {
          if (current !== "en") i18n.changeLanguage("en");
        } else if (!languages.includes(current)) {
          // Stored/browser choice isn't allowed on this store — use the default.
          i18n.changeLanguage(languages.includes(defaultLanguage) ? defaultLanguage : languages[0] || "en");
        }
      })
      .catch(() => {});
  }, [i18n]);

  const change = (code) => {
    if (cfg.enabled && cfg.languages.includes(code)) i18n.changeLanguage(code);
  };

  return (
    <LanguageContext.Provider value={{ ...cfg, current: (i18n.language || "en").slice(0, 2), change }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
